import { NotificationBadge } from '../elements/NotificationBadge';
import { SecondaryRouteTabs } from './RouteTabs.styled';

/**
 * Route-synced tab bar (no panel content). Use with separate React Router <Routes>.
 */
export function RouteTabs({
  items,
  activeKey,
  onChange,
  className,
  tabBarExtraContent,
  /** Show full-width nav rule (Settings Users-style nested tabs). Off in the app secondary header. */
  showNavBorder = false,
}) {
  const tabItems = items.map(({ key, value, label, text, count }) => {
    const tabLabel = label ?? text;
    return {
      key: key ?? value,
      label:
        count != null ? (
          <span className="d-flex align-items-center">
            {tabLabel}
            <NotificationBadge count={count} variant="inline" />
          </span>
        ) : (
          tabLabel
        ),
    };
  });

  return (
    <SecondaryRouteTabs
      type="line"
      className={['secondary-route-tabs', showNavBorder && 'with-nav-border', className]
        .filter(Boolean)
        .join(' ')}
      activeKey={activeKey}
      onChange={onChange}
      items={tabItems}
      tabBarExtraContent={tabBarExtraContent}
      styles={{
        header: { background: 'transparent', margin: 0 },
        content: { display: 'none' },
        contentHolder: { display: 'none' },
      }}
    />
  );
}
